import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import './styles/Modal.css';
import PropTypes from 'prop-types';

const MODAL_ROOT_ID = 'ej-modal-root';

function getModalRoot() {
    let root = document.getElementById(MODAL_ROOT_ID);
    if (!root) {
        root = document.createElement('div');
        root.id = MODAL_ROOT_ID;
        document.body.appendChild(root);
    }
    return root;
}

export function Modal({ children, isOpened, setIsOpened }) {
    useEffect(() => {
        if (!isOpened) {
            return undefined;
        }

        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';

        return () => {
            document.body.style.overflow = previousOverflow;
        };
    }, [isOpened]);

    function backgroundClick(event) {
        if (event.target === event.currentTarget) {
            setIsOpened(false);
        }
    }

    if (!isOpened) {
        return null;
    }

    return createPortal(
        <div className="ej-modal-overlay modal" onClick={backgroundClick} role="presentation">
            <div className="ej-modal-dialog content" onClick={(event) => event.stopPropagation()}>
                {children}
            </div>
        </div>,
        getModalRoot(),
    );
}

Modal.propTypes = {
    children: PropTypes.node.isRequired,
    isOpened: PropTypes.bool.isRequired,
    setIsOpened: PropTypes.func.isRequired,
};
